// extracted by mini-css-extract-plugin
export default {"sec_heading":"WebLink_sec_heading__4UqTK","weblink":"WebLink_weblink__-mycM"};